module.exports = __webpack_public_path__ + "packs/media/images/Einladung-0ffbd41f96137aeb4c28ce3a87d912bc.svg";